import { DateCalendar, LocalizationProvider } from '@mui/x-date-pickers';
import React, { useState } from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useNavigate } from 'react-router';
import PopupBox from '../../../components/PopupBox';

export default function Home() {
    const navigate=useNavigate()
    const [errorText, setErrorText] = useState('');
    const [show, setShow] = useState(false);
    const disableYet=()=>{
      setShow(true)
      setErrorText("این گزینه فعلا غیر فعال می باشد")
    }
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div className="home bg-white w-100 p-4 vh-100 align-content-stretch d-grid text-center ">
        <img src="/images/frame.png" id="frame" alt="" />
        <div className="calendar-box d-flex align-items-start justify-content-between body">
          <div className="calendar" dir="ltr">
            <DateCalendar disabled className="text-white" />
          </div>
          <div
            className="d-flex align-items-center h-100 pe-2"
            style={{ color: '#8A8C93' }}
          >
            <p>No more events today</p>
          </div>
        </div>
        <div className="buttons p-3">
          <div className="row">
            <div className="weather col-6 p-3">
              <div className="d-grid col-12 text-end">
                <span className="city">Metsavan</span>
                <span className="degree">14°</span>
              </div>
              <div className=" col-12 text-end justify-content-end mt-3">
                <img
                  src="/icons/cloudy.svg"
                  alt=""
                  className="w-auto d-block ms-auto pb-2"
                />
                <span className="col-12 d-block">Mostly Cloudy</span>
                <span className="col-12">H:16° L:8</span>
              </div>
            </div>
            <div className="col-6">
              <div className="row mb-2">
                <div className="col-6" role='button'  onClick={disableYet}>
                  <img src="/icons/book.svg" alt="" className="img-fluid" />
                  <sub>Books</sub>
                </div>
                <div className="col-6" role='button'  onClick={disableYet}>
                  <img src="/icons/calendar.svg" alt="" className="img-fluid" />
                  <sub>Calendar</sub>
                </div>
              </div>
              <div className="row">
                <div className="col-6" role='button'  onClick={disableYet}>
                  <img src="/icons/photos.svg" alt="" className="img-fluid" />
                  <sub>Photos</sub>
                </div>
                <div className="col-6" role='button'  onClick={disableYet}>
                  <img src="/icons/camera.svg" alt="" className="img-fluid" />
                  <sub>Camera</sub>
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-3" role='button'  onClick={disableYet}>
              <img src="/icons/note.svg" alt="" className="img-fluid" />
              <sub>Notes</sub>
            </div>
            <div className="col-3" role='button'  onClick={disableYet} >
              <img src="/icons/mail.svg" alt="" className="img-fluid" />
              <sub>Mail</sub>
            </div>
            <div className="col-3" role='button' onClick={()=>navigate("/one")}>
              <img src="/icons/sos.svg" alt="" className="img-fluid" />
              <sub>S.O.S</sub>
            </div>
            <div className="col-3" role='button'  onClick={disableYet}>
              <img src="/icons/player.svg" alt="" className="img-fluid" />
              <sub>Player</sub>
            </div>
          </div>
          <div className="mt-4 overflow-hidden p-1" role='button'>
            <span className="bg-dark border border-0 rounded-3 p-2  ">
              search
              <img src="/icons/search.svg" alt="" className='ps-2' />
            </span>
          </div>
        </div>
        <div className="nav row overflow-hidden" >
          <div className="col-3" role='button' onClick={()=>navigate("/menu")} >
            <img src="/icons/contacts-nav.svg" alt="" className="img-fluid" />
          </div>
          <div className="col-3" role='button'  onClick={disableYet}>
            <img src="/icons/message.svg" alt="" className="img-fluid" />
          </div>
          <div className="col-3" role='button'  onClick={disableYet}>
            <img src="/icons/safari.svg" alt="" className="img-fluid" />
          </div>
          <div className="col-3" onClick={()=>navigate("/one/contacts")}>
            <img src="/icons/calls.svg" alt="" className="img-fluid" />
          </div>
        </div>
        <PopupBox show={show} setShow={setShow} text={errorText} />
      </div>
    </LocalizationProvider>
  );
}
